import MlbNativeWrapper from '@gameday/utils/MlbNativeWrapper';
import getCookies from '@gameday/utils/getCookies';
import changeLoginAction from '@gameday/app/lib/store/actions/loginAction';
import changeUserInfoAction from '@gameday/app/lib/store/actions/userInfoAction';

export const oktaAuthPromise = () => {
  return new Promise((resolve) => {
    if (typeof window !== undefined && window.mlbOkta) {
      const okta = window.mlbOkta;  
      okta.isLoggedIn()
          .then((res) => {

              if (!res) {
                resolve(null);
              }
              resolve({
                  accessToken: res?.accessToken?.accessToken,
                  clientId: res?.idToken?.clientId,
                  uid: okta?.getToken('id_token')?.claims?.sub
              });
          })
          .catch((error) => {
              resolve(null);
          });

    } else {
      resolve(null);
    }
  });
};

export const mlbNativeAuthPromise = () => {
  return new Promise((resolve) => {
    if (MlbNativeWrapper) {
      const nativeOktaCookie = getCookies().get('native-okta-access-token');
      if (nativeOktaCookie) {
          return MlbNativeWrapper.then((results) => {
              const { getUser } = results;
              const { oktaId, entitlements } = getUser();
                  if (oktaId) {
                      const data = {
                          accessToken: nativeOktaCookie,
                          clientId: oktaId,
                          uid: oktaId,
                          entitlements
                      };
                      resolve(data)
                  }
          });
      } else {
          resolve(null);
      }
    } else {
      resolve(null);
    }    
  });   
};

const authReady = (dispatch) => {
    return Promise.allSettled([
        oktaAuthPromise(),
        mlbNativeAuthPromise()
    ]).then(([oktaData, mlbNativeData]) => {
        const authInfoData =  oktaData?.value || mlbNativeData?.value;
        if (dispatch && authInfoData) {
                const { accessToken, clientId, entitlements, uid } = authInfoData;
                const data = {
                    accessToken, 
                    clientId, 
                    entitlements, 
                    uid
                };  
            dispatch(changeUserInfoAction(data));
            dispatch(changeLoginAction(true));
        }
        return authInfoData;
    });
};

export default authReady;